import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import * as styles from './FinaleTopBanner.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FinaleTopBanner = function FinaleTopBanner() {
  return /*#__PURE__*/_jsxs("div", {
    className: styles['wrapper'],
    children: [/*#__PURE__*/_jsxs(UIText2, {
      color: "black_100",
      children: ["\u041C\u044B \u043F\u0440\u043E\u0432\u0435\u0440\u044F\u0435\u043C \u043A\u0430\u0436\u0434\u0443\u044E \u0436\u0430\u043B\u043E\u0431\u0443. \u0415\u0441\u043B\u0438 \u0432\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u044F\u043B\u0438 \u0436\u0430\u043B\u043E\u0431\u0443,", /*#__PURE__*/_jsx("br", {}), "\u043D\u043E \u043D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043E\u0442\u0432\u0435\u0442\u0430, \u0437\u043D\u0430\u0447\u0438\u0442, \u0441\u043B\u0443\u0436\u0431\u0430 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0430 \u043D\u0435 \u043D\u0430\u0448\u043B\u0430 \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u0439."]
    }), /*#__PURE__*/_jsxs(UIText2, {
      color: "black_100",
      children: ["\u0415\u0441\u043B\u0438 \u043D\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u044B \u2014", ' ', /*#__PURE__*/_jsx("a", {
        className: styles['link'],
        href: "https://support.cian.ru/ru/knowledge_base/article/218/category/68/",
        target: "_blank",
        rel: "noreferrer",
        children: "\u043E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u0436\u0430\u043B\u043E\u0431\u0443 \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E"
      }), "."]
    })]
  });
};